var _defs, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80,
    height: 69.362,
    viewBox: "0 0 80 69.362",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#14ffa1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15e584"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_3668865_beauty_health_heart_icon",
    "data-name": "3668865_beauty_health_heart_icon",
    d: "M75.939,12.383h0c-9.41-9.41-24.013-9.41-33.1,0h0a23.5,23.5,0,0,0-33.1,0,23.162,23.162,0,0,0-1.3,31.8,168.116,168.116,0,0,0,12.98,13.3c1.947-.973,4.543-1.947,6.814-3.245h0a41.385,41.385,0,0,0,15.9-13.3,51.908,51.908,0,0,1-18.5,8.437,13.936,13.936,0,0,1,3.245-13.629c4.867-4.867,18.821-6.165,23.688-13.953a1.519,1.519,0,0,1,2.6,0c2.271,5.192,6.165,17.523-2.272,30.178-4.218,6.49-13.629,9.41-20.443,5.841-2.271,1.622-4.543,3.245-6.165,4.218A159.2,159.2,0,0,0,42.84,74.687a156.33,156.33,0,0,0,34.721-30.5A24.223,24.223,0,0,0,75.939,12.383Z",
    transform: "translate(-2.743 -5.325)",
    fill: "url(#linear-gradient)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.aec772ec2bfcd977ae4efb8cc1a186cb.svg";
export { ForwardRef as ReactComponent };